<template>
    <div class="top" v-if="type!='multiple'">
      <div class="title">
        {{ $t('seller.brandsPage.selectedBrand') }}
      </div>
      <div class="bottom">
        <LogoImage :maxWidth="'95%'" :logoUrl="itemData?.publicImage" :brandName="itemData?.name" :width="68"
          :height="68" :fontSize="14" />
        <div class="bottom-title">
          {{ itemData?.name }}
        </div>
      </div>
    </div>
    
    <div class="content">
      <div class="title">
        {{ $t('seller.brandsPage.selectPublishersTitle') }}
      </div>
      <div class="table">
        <div class="table-head">
          <a-space>
            <ButtonGroups :pagination="pagination" :tableData="dataSource" @pageChange="onPageChange" />
          </a-space>
          <a-space>
            <a-input-search v-model:value="value5" :placeholder="$t('seller.common.searchPlaceholder')" allow-clear @search="onSearch"
              @enter="onSearch">
            </a-input-search>
          </a-space>
        </div>
        <!-- <div class="filters">
          <div class="filter-item">
            <div class="label">
              Partnership Status:
            </div>
            <artemisads-segmented class="segmented"
              v-model:value="filter.associateBrandProgress"
              @change="handleChange"
              :options="['All', 'Partnered', 'Not Partnered']" />
          </div>
        
          <div class="filter-item">
            <div class="label">
              ACC Authorization:
            </div>
            <artemisads-segmented class="segmented"
              v-model:value="filter.accAuthorization"
              @change="handleChange"
              :options="['All', 'Authorized', 'Not Authorized']" />
          </div>
        </div> -->
        <div class="table-content">
          <artmisads-table
            :row-selection="{
              selectedRowKeys: selectedRowKeys,
              onChange: onSelectChange,
            }"
            :row-key="record => record.id"
            v-model:pagination="pagination"
            :columns="columns"
            :data-source="dataSource"
            :change="onTableChange"
            :loading="loading"
            :scroll="{ x: 1200 }"
          >
            <template #bodyCell="{ column, text, record }">
              <template v-if="column.dataIndex === 'publisher'">
                <div class="brand-item">
                  <LogoImage :maxWidth="'95%'" :logoUrl="record.publicImage" :brandName="record.creatorName" :width="56"
                    :height="56" :fontSize="10" :borderRadius="4" />
                  <div class="brand-name">{{ record.creatorName }}</div>
                </div>
              </template>
              <template v-else-if="column.dataIndex === 'countries'">
                {{ retrunName(record.promotionCountries) }}
              </template>
              <template v-else-if="column.dataIndex === 'promotionMethods'">
                {{ retrunName(record.promotionMethods) }}
              </template>
              <template v-else-if="column.dataIndex === 'promotionProductCategories'">
                {{ retrunName(record.promotionProductCategories) }}
              </template>
              <template v-else-if="column.dataIndex === 'actions'">
                <div class="actions">
                  <artmisads-button :isSquare="true" size="middle" type="default" @click="handleViewDetails(record)">
                    View Details
                  </artmisads-button>
                </div>
              </template>
              <!-- <template v-else-if="column.dataIndex === 'associateStatus'">
                <Status :type="record.associateStatus.toLowerCase()" :noBorder="true"
                  :text="record.associateStatus == 'active' ? 'Active' : 'Inactive'" />
              </template>
              <template v-else-if="column.dataIndex==='ccAuthorizationStatus'">
                  <Status :type="record.ccAuthorizationStatus.toLowerCase()" :noBorder="true"
                  :text="capitalize(record.ccAuthorizationStatus.toLowerCase())" />
              </template> -->
            </template>
          </artmisads-table>
        </div>
      </div>
    </div>
    <div class="bottomFix">
      <div class="total">
        Selected Publishers ({{ allSelectedKeys.size }} /<span class="totalStyle">{{ pagination.total }}</span>)
      </div>
      <div class="bottomFixContent">
        Setting up on  <Icon :name="CURRENCY_MAPPER[amazonCountryCode].icon" class="icon"></Icon>{{ CURRENCY_MAPPER[amazonCountryCode].host }}. For other country stores, switch country on the top right.
      </div>
      <div>
        <artmisads-button type="primary" @click="goNext" :disabled="allSelectedKeys.size === 0">
          Next
        </artmisads-button>
      </div>
    </div>
  
</template>

<script setup>
import i18n from '~/i18n'

import { ref, defineProps, defineEmits ,onMounted,watch, computed} from 'vue'
import { useI18n } from 'vue-i18n'
import LogoImage from '@/components/LogoImage.vue'
import ButtonGroups from './buttonGroups.vue'
import Status from '@/components/Status.vue'
import { CURRENCY_MAPPER } from '@/contants/common'
import Icon from '@/components/Icon.vue'
import { useUserInfoStore } from '@/storeData/index'
import { publishersApi } from '@/server'
import { message } from 'ant-design-vue'
import { countBrandNames } from '~/utils'
import {capitalize} from '~/utils'
const { t, locale } = useI18n()
const loading=ref(false)
const amazonCountryCode = ref('')
const store = useUserInfoStore()
const userInfo = store.userInfo
watch(() => userInfo.countryCode, () => {
  amazonCountryCode.value = userInfo.countryCode
}, { immediate: true })
// Define props
const pagination = ref({
  total: 0,
  defaultPageSize: 10,
  current: 1,
  showSizeChanger: true,
  pageSize: 10,
  pageSizeOptions: ['10', '20', '30', '40', '50']
})
const selectedRowKeys=ref([]) // 当前页面显示的选中项
const allSelectedKeys=ref(new Set()) // 所有页面的选中项集合
const allSelectedPublishers=ref(new Map()) // 存储所有选中发布者的完整数据
const filter=ref({
  associateBrandProgress: 'All',
  accAuthorization:"All",
})
const columns = computed(() => {
  locale.value
  return [
    {
      title: t('seller.brandsPage.colPublisher'),
      dataIndex: 'publisher',
      key: 'publisher',
      width: 100,
    },
    {
      title: t('seller.brandsPage.colPromotionCountries'),
      dataIndex: 'countries',
      key: 'countries',
      width: 200,
    },
    {
      title: t('seller.brandsPage.colPromotionMethod'),
      dataIndex: 'promotionMethods',
      key: 'promotionMethods',
      width: 200,
    },
    {
      title: t('seller.brandsPage.colPromotionCategories'),
      dataIndex: 'promotionProductCategories',
      key: 'promotionProductCategories',
      width: 200,
    },
    {
      title: t('seller.brandsPage.colActionsTable'),
      dataIndex: 'actions',
      key: 'actions',
      width: 200,
    },
  ]
})
const itemData=ref({})
// Define events
const emit = defineEmits(['pageChange', 'search', 'selectChange', 'tableChange', 'change', 'goNext'])
const onSelectChange = (keys, selectedRows) => {
  // Update current page selected keys
  selectedRowKeys.value = keys
  const currentPageBrandIds = dataSource.value.map(item => item.id)
  currentPageBrandIds.forEach(brandId => {
  if (keys.includes(brandId)) {
    // 如果品牌在选中列表中，添加到全局选择
    const row = dataSource.value.find(item => item.id === brandId)
    if (row) {
      allSelectedKeys.value.add(brandId)
      allSelectedPublishers.value.set(brandId, row)
    }
  } else {
    // 如果品牌不在选中列表中，从全局选择中移除
    allSelectedKeys.value.delete(brandId)
    allSelectedPublishers.value.delete(brandId)
  }
})
  // allSelectedKeys.value.clear()
  // allSelectedPublishers.value.clear()

  // Update global selection set and publisher data
  // selectedRows.forEach(row => {
  //   const rowKey = row.id
  //   if (keys.includes(rowKey)) {
  //     // Add selected item
  //     allSelectedKeys.value.add(rowKey)
  //     allSelectedPublishers.value.set(rowKey, row)
  //   } else {
  //     // Remove deselected item
  //     allSelectedKeys.value.delete(rowKey)
  //     allSelectedPublishers.value.delete(rowKey)
  //   }
  // })
  
  // Limit maximum selection to 100 items
  // if (allSelectedKeys.value.size > 100) {
  //   message.error('Maximum 100 publishers can be selected')
    
  //   // Keep only first 100 selected items
  //   const limitedKeys = Array.from(allSelectedKeys.value).slice(0, 100)
  //   allSelectedKeys.value = new Set(limitedKeys)
    
  //   // Update publisher data map
  //   allSelectedPublishers.value = new Map(
  //     Array.from(allSelectedPublishers.value).filter(([key]) => limitedKeys.includes(key))
  //   )
    
  //   // Update current page display
  //   const currentPageKeys = new Set(selectedRows.map(row => row.id))
  //   selectedRowKeys.value = limitedKeys.filter(key => currentPageKeys.has(key))
  // }
}
const dataSource = ref([])
const brandList = ref([])
const value5 = ref('')

const onSearch = () => {
  getBrandsList()
}

const getBrandsList = async (value) => {
  loading.value = true
  try {
    const res = await publishersApi.getPublishers({
      page: pagination.value.current,
      size: pagination.value.pageSize,
      associateEnable:1,
      // keyword: queryParams.value.keywords,
      keyword:value5.value,
      // status:filter.value.associateBrandProgress!=='All'?filter.value.associateBrandProgress==='Partnered'?'active':'inactive':undefined,
      // ccAuthorizationStatus:filter.value.accAuthorization!=='All'?filter.value.accAuthorization==='Authorized'?'authorized':'not_authorized':undefined
    })
    if (res.success) {
      dataSource.value =res.data?.data?.map((item) => ({
          ...item.publisherVO,
          associateBrandCount: item.associateBrandCount,
          currentCommissionDetail: item.currentCommissionDetail,
          checked: false,
        }))
      pagination.value.total = res.data.total
      
      // Restore selection state after data refresh
      const currentPageKeys = dataSource.value.map(item => item.id)
      selectedRowKeys.value = Array.from(allSelectedKeys.value).filter(key => currentPageKeys.includes(key))
      
      // Update selected publishers' data with fresh data
      dataSource.value.forEach(item => {
        if (allSelectedKeys.value.has(item.id)) {
          allSelectedPublishers.value.set(item.id, item)
        }
      })
    } else {
      message.error(res.error)
    }
  } catch (error) {
   
    message.error(i18n.global.t('seller.brandsPage.failedGetData'))
  } finally {
    loading.value = false
  }
}
// const getList = async () => {
//   loading.value = true
//   try {
//     const res = await publishersApi.getPublishers({
//       page: pagination.value.page,
//       size: pagination.value.size,
//       keyword: queryParams.value.keywords,
//       associateBrandProgress: filter.value.associateBrandProgress === 'Partnered' ? '1' :filter.value.associateBrandProgress === 'Not Partnered' ? '0' : undefined,
//       associateEnable: !checked.value ? undefined : '1'
//     })
//     if (res.success) {
//       dataSource.value = res.data?.data?.map(item => ({
//         ...item.publisherVO,
//         associateBrandCount: item.associateBrandCount
//       }))
//       dataSource.value?.forEach(item => {
//         if (item?.links) {
//           item.links = item?.links?.filter(link => {
//             return link.url
//           })
//         }
//       })
//       pagination.value.total = res.data.total
//     } else {
//       message.error(res.error)
//     }
//   } catch (error) {
//     console.error('获取数据失败:', error)
//     message.error(i18n.global.t('seller.msg.getDataFailed'))
//   } finally {
//     loading.value = false
//   }
// }


const onTableChange = ({ current, pageSize }) => {
  pagination.value.current = current
  pagination.value.pageSize = pageSize
  getBrandsList({ page: current, size: pageSize })
}
const onPageChange = (current) => {
 pagination.value.current = current;
 getBrandsList()
}
  const handleChange = (value) => {
    
    pagination.value.page = 1
    getBrandsList(value)
  }
const goNext = () => {
  // Get all selected publishers' complete data
  const selectedPublishers = Array.from(allSelectedPublishers.value.values())
  const selectedIds = Array.from(allSelectedKeys.value)
  emit('goNext', selectedPublishers, selectedIds, 1)
}
const retrunName=(countries)=>{
  if(countries){
    return countries.map(item=>item.name).join(',')
  }
  return ''
}
const handleViewDetails=(record)=>{

  window.open(`/seller/publishers/${record.id}`, '_blank')
}
onMounted(() => {
  itemData.value = JSON.parse(sessionStorage.getItem('brandDetail'))
  getBrandsList()
})
</script>

<style scoped lang="less">
.top {
  padding: 20px 16px;
  background-color: #fff;
  border-radius: 8px;
  margin-top: 16px;

  .bottom {
    display: flex;
    align-items: center;
    gap: 16px;
    margin-top: 16px;

    .bottom-title {
      font-family: Sora;
      font-weight: 500;
      font-style: Medium;
      font-size: 18px;
      color: #0F0629;
    }
  }
}

.content {
  background-color: #fff;
  border-radius: 8px;
  margin-top: 16px;
  padding: 20px 16px;
}

.title {
  font-family: Sora;
  font-weight: 600;
  font-size: 20px;
  color: #0F0629;
  padding-bottom: 16px;
  border-bottom: 1px solid #E8E5ED;
}

.table {
  margin-bottom: 64px;
}

.table-head {
  display: flex;
  height: 64px;
  justify-content: space-between;
  align-items: center;
  padding: 32px 0;
}

.filters {
  display: flex;
  gap: 22px;
  padding: 15px 16px;
  margin: 16px 0;
  border-radius: 8px;
  background: #F8F7FC;

  .filter-item {
    .label {
      color: #0f0629;
      font-family: "Sora";
      font-size: 14px;
      font-style: normal;
      font-weight: 500;
      margin-bottom: 8px;
      opacity: 0.9;
    }
  }
}

.table-content {
  // Table content styles if needed
}

.brand-item {
  display: flex;
  align-items: center;
  gap: 10px;
}

.bottomFix {
  position: sticky;
  bottom: 0px;
  height: 64px;
  border: 1px solid #E8E5ED;
  background-color: #fff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 16px;
z-index: 999;

}

.total {
  font-family: Sora;
  font-weight: 400;
  font-style: Regular;
  font-size: 14px;
  color: rgba(15, 6, 41, 1);
}

.totalStyle {
  font-family: Sora;
  font-weight: 400;
  font-style: Regular;
  font-size: 12px;
  color: rgba(15, 6, 41, 0.5);
}

.bottomFixContent {
  font-family: Sora;
  font-weight: 400;
  font-style: Regular;
  font-size: 14px;
  display: flex;
  align-items: center;

  .icon {
    margin: 2px 2px 0;
    font-size: 16px;
  }
}
</style>